import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from '../../shared/http.service';
import { IUserDetails } from '../user-datails';
//import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx';
// import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { AppSettings } from '../../shared/app-settings'
import { ConfigService } from 'app/shared/config.service';
@Injectable()
export class UpdateDetailsService {

    private apiUrl: string = "";

    constructor(private _http: HttpService, private _configService : ConfigService) 
    {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
        //this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
    }


    getUserDetails(): Observable<IUserDetails> {
        let url : string  = `${this.apiUrl}/api/User/GetUserKeepInTouch`
        return this._http.get(url)
            .map((response: Response) => <IUserDetails>response.json())
            .catch(this.handleError);
    }

        

        saveUserDetails(user: IUserDetails): Observable<IUserDetails> {
            let url : string = `${this.apiUrl}/api/User/SaveUserKeepInTouch`
        return this._http.post(url, JSON.stringify(user))
            .map(res => res.json())
            .catch(this.handleError)
    }

    private handleError(error: Response | any) {
        // In a real world app, we might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            console.log(err);
            if (body.error == 'invalid_grant' || body.error == "auth_error") {
                errMsg = `${body.error_description} `;
            }
            else {
                errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}